import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';
import { Angulartics2 } from 'angulartics2';

declare var alertify: any;

@Component({
  selector: 'app-duplicateappleid',
  templateUrl: './duplicateappleid.component.html',
  styleUrls: ['./duplicateappleid.component.scss']
})

export class DuplicateAppleId implements OnInit {

  email: any = "";

  constructor(
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private angulartics2: Angulartics2
   ) {
    this.loaderService.setLoaded();
    }

  ngOnInit() {

    this.angulartics2.eventTrack.next({ action: 'Duplicate Apple ID', properties: { category: 'Auth' } });

    // get the email address from the query param
    this.route.queryParams
      .subscribe(params => {
        console.log(params); 
        this.email = params.email;
      }
    );

  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/duplicateappleid/duplicateappleid.component.ts